/* pf-legal.js — zerlegt einen Rechtstext in Boxen.

   Die Rechtstexte liegen als ein zusammenhängender HTML-Block in den Shopify-
   Richtlinien. Ihre Gliederung steckt in den Absätzen, die mit einem fetten
   Wort beginnen ("<p><strong>Geltungsbereich</strong><br>…"). Genau daran wird
   hier geschnitten: jede solche Stelle beginnt eine neue Box, das fette Wort
   wird zur Überschrift.

   Fällt dieses Skript aus, passiert nichts weiter — der Rechtstext steht dann
   am Stück da, von pf-legal.css vollständig gesetzt und lesbar. Das ist
   Absicht: an einem Rechtstext darf nichts davon abhängen, ob ein Skript lädt.

   Die Einstellungen kommen aus dem Konfigurations-Element, das die Section
   pf-legal rendert. Fehlt es, bleibt alles, wie es ist. */
(function () {
  'use strict';

  var CORNERS = ['tl', 'tr', 'bl', 'br'];

  function addCorners(box) {
    for (var i = 0; i < CORNERS.length; i++) {
      var c = document.createElement('i');
      c.className = 'pf-corner ' + CORNERS[i];
      box.appendChild(c);
    }
  }

  function slug(text, fallback) {
    var s = (text || '')
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return s || fallback;
  }

  /* Beginnt dieser Absatz eine neue Box? Nur wenn er mit <strong> anfängt und
     davor kein Text steht — ein fettes Wort mitten im Satz zählt nicht.

     Manche Abschnitte führen Haupt- und Zwischenüberschrift in einem einzigen
     <strong>, getrennt durch einen Zeilenumbruch ("Lieferung<br>Liefergebiet").
     Dann wird die erste Zeile zur Überschrift der Box, der Rest zur
     Zwischenüberschrift darin. */
  function headingOf(el) {
    if (el.tagName !== 'P') return null;
    var strong = el.firstElementChild;
    if (!strong || (strong.tagName !== 'STRONG' && strong.tagName !== 'B')) return null;

    // Steht vor dem <strong> schon Text? Dann ist es keine Überschrift.
    var before = '';
    for (var n = el.firstChild; n && n !== strong; n = n.nextSibling) {
      before += n.textContent || '';
    }
    if (before.trim()) return null;

    var lines = [];
    var buf = '';
    for (var c = strong.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 1 && c.tagName === 'BR') { lines.push(buf); buf = ''; continue; }
      buf += c.textContent || '';
    }
    lines.push(buf);

    var clean = [];
    for (var k = 0; k < lines.length; k++) {
      var t = lines[k].trim();
      if (t) clean.push(t);
    }
    if (!clean.length || clean[0].length > 90) return null;

    return { title: clean[0], sub: clean.slice(1).join(' — ') };
  }

  function stripLeadingBreaks(node) {
    while (node.firstChild) {
      var f = node.firstChild;
      if (f.nodeType === 3 && !f.textContent.trim()) { node.removeChild(f); continue; }
      if (f.nodeType === 1 && f.tagName === 'BR') { node.removeChild(f); continue; }
      break;
    }
  }

  /* ── Kopfband: Brotkrumen, Eyebrow und Einleitung ergänzen ───────────── */
  function buildHead(cfg, titleBox) {
    if (!titleBox) return;
    var h1 = titleBox.querySelector('h1');
    var before = [];

    if (cfg.getAttribute('data-crumb') === 'true') {
      var nav = document.createElement('nav');
      nav.className = 'pfl-crumb';
      nav.setAttribute('aria-label', 'Brotkrumen');
      var a = document.createElement('a');
      a.href = cfg.getAttribute('data-home-url') || '/';
      a.textContent = cfg.getAttribute('data-home-label') || 'Start';
      var sep = document.createElement('span');
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '›';
      var cur = document.createElement('span');
      cur.className = 'pfl-current';
      cur.textContent = h1 ? (h1.textContent || '').trim() : document.title;
      nav.appendChild(a); nav.appendChild(sep); nav.appendChild(cur);
      before.push(nav);
    }

    var eyebrow = cfg.getAttribute('data-eyebrow') || '';
    var number = cfg.getAttribute('data-number') || '';
    if (eyebrow || number) {
      var eb = document.createElement('div');
      eb.className = 'pfl-eyebrow';
      if (number) {
        var nm = document.createElement('span');
        nm.className = 'pfl-num';
        nm.textContent = number;
        eb.appendChild(nm);
      }
      if (eyebrow) eb.appendChild(document.createTextNode(eyebrow));
      before.push(eb);
    }

    for (var i = 0; i < before.length; i++) {
      titleBox.insertBefore(before[i], h1 || null);
    }

    var intro = cfg.getAttribute('data-intro') || '';
    if (intro && h1) {
      var p = document.createElement('p');
      p.className = 'pfl-lede';
      var span = document.createElement('span');
      span.textContent = intro;
      p.appendChild(span);
      titleBox.insertBefore(p, h1.nextSibling);
    }
  }

  /* ── Hinweiskasten unter dem Text ────────────────────────────────────── */
  function buildNote(cfg, holder) {
    var text = cfg.getAttribute('data-note-text') || '';
    if (!text.trim() || !holder) return;

    var aside = document.createElement('aside');
    aside.className = 'pfl-note' + (cfg.getAttribute('data-frame') === 'true' ? ' pf-bp' : '');
    if (cfg.getAttribute('data-frame') === 'true') addCorners(aside);

    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('width', '20');
    icon.setAttribute('height', '20');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('fill', 'none');
    icon.setAttribute('stroke', 'currentColor');
    icon.setAttribute('stroke-width', '1.5');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<circle cx="12" cy="12" r="9"></circle><path d="M12 16v-5"></path><path d="M12 8h.01"></path>';

    var body = document.createElement('div');
    body.className = 'pfl-note-body';
    var title = cfg.getAttribute('data-note-title') || '';
    if (title) {
      var t = document.createElement('div');
      t.className = 'pfl-note-title';
      t.textContent = title;
      body.appendChild(t);
    }
    var wrap = document.createElement('div');
    wrap.innerHTML = text;   // Richtext aus den Section-Einstellungen
    while (wrap.firstChild) body.appendChild(wrap.firstChild);

    aside.appendChild(icon);
    aside.appendChild(body);
    holder.appendChild(aside);
  }

  /* ── Text in Boxen zerlegen ──────────────────────────────────────────── */
  function boxify(cfg, rte) {
    if (cfg.getAttribute('data-split') !== 'true') return;

    var frame = cfg.getAttribute('data-frame') === 'true';
    var numbered = cfg.getAttribute('data-numbered') === 'true';
    var wantToc = cfg.getAttribute('data-toc') === 'true';
    var leadTitle = cfg.getAttribute('data-lead-title') || 'Vorbemerkung';

    var kids = Array.prototype.slice.call(rte.children);
    if (!kids.length) return;

    /* Erst zählen, dann umbauen. Würden wir sofort umbauen und erst danach
       abbrechen, stünde der Rechtstext nicht mehr da: appendChild verschiebt
       die Absätze, sie wären dann schon in die verworfenen Boxen gewandert.
       Unter drei Boxen lohnt die Aufteilung nicht — dann bleibt der Text am
       Stück, unangetastet. */
    var planned = 0;
    var seenHeading = false;
    for (var j = 0; j < kids.length; j++) {
      if (headingOf(kids[j])) { planned++; seenHeading = true; continue; }
      if (!seenHeading && planned === 0) {
        var lead = kids[j];
        if ((lead.textContent || '').trim() || lead.querySelector('img, table')) planned++;
      }
    }
    if (planned < 3) return;

    var frag = document.createDocumentFragment();
    var target = null;
    var boxes = [];

    function openBox(title) {
      var box = document.createElement('section');
      box.className = 'pfl-box' + (frame ? ' pf-bp' : '');
      if (frame) addCorners(box);

      var h = document.createElement('h2');
      h.className = 'pfl-box-title';
      h.id = 'abschnitt-' + slug(title, String(boxes.length + 1));
      if (numbered) {
        var nr = document.createElement('span');
        nr.className = 'pfl-box-nr';
        nr.textContent = ('0' + (boxes.length + 1)).slice(-2);
        h.appendChild(nr);
      }
      h.appendChild(document.createTextNode(title));
      box.appendChild(h);

      var inner = document.createElement('div');
      inner.className = 'pfl-box-body';
      box.appendChild(inner);

      frag.appendChild(box);
      boxes.push({ title: title, id: h.id });
      return inner;
    }

    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      var head = headingOf(el);

      if (head) {
        target = openBox(head.title);
        el.removeChild(el.firstElementChild);   // das <strong> raus
        stripLeadingBreaks(el);
        if (head.sub) {
          var subline = document.createElement('p');
          subline.className = 'pfl-sub';
          subline.textContent = head.sub;
          target.appendChild(subline);
        }
        if ((el.textContent || '').trim()) target.appendChild(el);
        continue;
      }

      // Text vor der ersten Überschrift bekommt eine eigene Box, sonst ginge er verloren.
      if (!target) {
        if (!(el.textContent || '').trim() && !el.querySelector('img, table')) continue;
        target = openBox(leadTitle);
      }
      target.appendChild(el);
    }

    rte.textContent = '';
    rte.appendChild(frag);
    rte.classList.add('is-boxed');

    if (wantToc) {
      var toc = document.createElement('nav');
      toc.className = 'pfl-toc';
      toc.setAttribute('aria-label', cfg.getAttribute('data-toc-label') || 'Inhalt');
      boxes.forEach(function (b) {
        var a = document.createElement('a');
        a.href = '#' + b.id;
        a.textContent = b.title;
        toc.appendChild(a);
      });
      rte.parentNode.insertBefore(toc, rte);
    }
  }

  function boot() {
    var cfg = document.getElementById('pf-legal-config');
    if (!cfg || cfg.getAttribute('data-pf-legal-done') === '1') return;

    var holder = document.querySelector('.shopify-policy__body');
    var rte = holder && holder.querySelector('.rte');
    if (!rte) return;
    cfg.setAttribute('data-pf-legal-done', '1');

    buildHead(cfg, document.querySelector('.shopify-policy__title'));
    boxify(cfg, rte);
    buildNote(cfg, holder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();